/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
function emptyFunction() {}

const handleBackPress = () => {
  const listeners = BackHandler.listeners;
  // Go from most recent registered to first registered.
  // If callback returns true, then do not call any other callbacks.
  listeners.reduceRight((handled, listener, index) => {
    if(!handled) {
      return listener.callback() ?? false;
    }
    return handled;
  }, false);
}

var BackHandler = {
  register: function register() {
    document.removeEventListener(`hardwareBackPress`, handleBackPress);
    document.addEventListener(`hardwareBackPress`, handleBackPress);
    this.registered = true;
  },
  registered: false,
  listeners: [],
  /**
   * Does nothing for now
   */
  exitApp: emptyFunction,
  /**
   * Listen to "hardwareBackPress" event
   *
   * @param event
   * @param callback
   * @returns {{remove: remove}}
   */
  addEventListener: function addEventListener(event, callback, priority = 0) {
    if(!this.registered) {
      this.register();
    }

    this.listeners.push({callback, priority});
    this.listeners.sort((a, b) => a.priority - b.priority);

    const remove = () => {
      this.removeEventListener(event, callback);
    }

    return { remove }
  },

  /**
   * Removes listener for back events
   * @param event
   * @param callback
   */
  removeEventListener: function removeEventListener(event, callback) {
    var index = this.listeners.findIndex((listener) => listener.callback === callback);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }
};

export default BackHandler;
